var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, makeObservable, observable } from 'mobx';
import API from '../../util/ApiUtil';
export default class PersonContactInfoStore {
    constructor(rootStore) {
        Object.defineProperty(this, "phone", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "email", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "communicationLanguage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "translateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "ssoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "loadPersonContactInfo", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async () => {
                this.fetchPersonCommunicationLanguage();
                this.fetchPersonContactEmail();
                this.fetchPersonContactPhone();
            }
        });
        Object.defineProperty(this, "handleContactInfoFetchError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (e, type) => {
                console.error(e);
                type === 'EMAIL' ? (this.email = null) : (this.phone = null);
            }
        });
        Object.defineProperty(this, "handleContactInfoFetchSuccess", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (response, type) => {
                type === 'EMAIL' ? (this.email = response.data) : (this.phone = response.data);
            }
        });
        Object.defineProperty(this, "handleLanguageFetchSuccess", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (response) => {
                if (response.data) {
                    this.communicationLanguage = response.data;
                }
            }
        });
        Object.defineProperty(this, "handleLanguageFetchError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (e) => {
                this.communicationLanguage = null;
                console.error(e);
            }
        });
        makeObservable(this);
        this.translateStore = rootStore.translateStore;
        this.ssoStore = rootStore.ssoStore;
    }
    async fetchPersonContactPhone() {
        return API.get('/person-data/phone')
            .then((response) => this.handleContactInfoFetchSuccess(response, 'PHONE'))
            .catch((e) => this.handleContactInfoFetchError(e, 'PHONE'));
    }
    async fetchPersonContactEmail() {
        return API.get('/person-data/e-mail')
            .then((response) => this.handleContactInfoFetchSuccess(response, 'EMAIL'))
            .catch((e) => this.handleContactInfoFetchError(e, 'EMAIL'));
    }
    async fetchPersonCommunicationLanguage() {
        return API.get('/person-data/communication-language-code').then(this.handleLanguageFetchSuccess).catch(this.handleLanguageFetchError);
    }
}
__decorate([
    observable
], PersonContactInfoStore.prototype, "phone", void 0);
__decorate([
    observable
], PersonContactInfoStore.prototype, "email", void 0);
__decorate([
    observable
], PersonContactInfoStore.prototype, "communicationLanguage", void 0);
__decorate([
    action.bound
], PersonContactInfoStore.prototype, "loadPersonContactInfo", void 0);
__decorate([
    action.bound
], PersonContactInfoStore.prototype, "fetchPersonContactPhone", null);
__decorate([
    action.bound
], PersonContactInfoStore.prototype, "fetchPersonContactEmail", null);
__decorate([
    action.bound
], PersonContactInfoStore.prototype, "fetchPersonCommunicationLanguage", null);
__decorate([
    action.bound
], PersonContactInfoStore.prototype, "handleContactInfoFetchError", void 0);
__decorate([
    action.bound
], PersonContactInfoStore.prototype, "handleContactInfoFetchSuccess", void 0);
__decorate([
    action.bound
], PersonContactInfoStore.prototype, "handleLanguageFetchSuccess", void 0);
__decorate([
    action.bound
], PersonContactInfoStore.prototype, "handleLanguageFetchError", void 0);
